import { ITrackEvents } from './useAnalytics';

// This file contains the old event records for finance analytics. Most of them were extracted
// from mixpanel events, but some were extracted from flies that had event strings inline.
// please fo not add events to this file
export const oldEventRecords = {
    DashboardEventsLoadedDashboard: {
        eventName: 'finance dashboard',
        eventType: 'load'
    },
    DashboardEventsClickDocuments: {
        eventName: 'finance app download document',
        eventType: 'click'
    },
    DashboardEventsClickActions: {
        eventName: 'finance app actions',
        eventType: 'click'
    },
    DashboardEventsClickTransaction: {
        eventName: 'finance app transaction',
        eventType: 'click'
    },
    DashboardEventsDownloadDocumentsMenu: {
        eventName: 'finance app download documents menu',
        eventType: 'click'
    },
    DashboardEventsLoadTransactionDetails: {
        eventName: 'finance app transaction detail',
        eventType: 'load'
    },
    DashboardEventsClickShowNumber: {
        eventName: 'finance app show number',
        eventType: 'click'
    },
    DashboardEventsClickHideNumber: {
        eventName: 'finance app hide number',
        eventType: 'click'
    },
    DashboardEventsClickShowCardModal: {
        eventName: 'finance app show card',
        eventType: 'click'
    },
    DashboardEventsAuthFormLoaded: {
        eventName: 'finance app load auth form',
        eventType: 'load'
    },
    DashboardEventsAuthCodeSubmitted: {
        eventName: 'finance app submit auth code',
        eventType: 'submit'
    },
    DashboardEventsAuthSubmitted: {
        eventName: 'finance app auth form submit',
        eventType: 'click'
    },
    DashboardEventsAuthModalClose: {
        eventName: 'finance app auth form close',
        eventType: 'click'
    },
    DashboardEventsTransactionSelectCategory: {
        eventName: 'transaction select category',
        eventType: 'click'
    },

    DashboardEventsTransactionSelectCategorySuccess: {
        eventName: 'transaction select category',
        eventType: 'success'
    },

    DashboardEventsTransactionSelectCategoryError: {
        eventName: 'transaction select category',
        eventType: 'error'
    },
    DashboardEventsTransactionSelectProject: {
        eventName: 'transaction select project',
        eventType: 'click'
    },
    DashboardEventsTransactionSelectProjectSuccess: {
        eventName: 'transaction select project',
        eventType: 'success'
    },
    DashboardEventsTransactionSelectProjectError: {
        eventName: 'transaction select project',
        eventType: 'error'
    },
    DashboardEventsOpenExpenseProject: {
        eventName: 'finance app open expense project',
        eventType: 'click'
    },
    DashboardEventsTxFeedEmptyStateOrderCardClick: {
        eventName: 'finance app transaction feed empty state order card',
        eventType: 'click'
    },
    SetupListEventsListLoaded: {
        eventName: 'finance app setup list',
        eventType: 'load'
    },
    SetupListEventsClickCollapseExpand: {
        eventName: 'finance app setup list collapse',
        eventType: 'click'
    },
    SetupListEventsClickListItem: {
        eventName: 'finance app setup list item',
        eventType: 'click'
    },
    SetupListEventsClickHide: {
        eventName: 'finance app setup list not interested',
        eventType: 'click'
    },
    CardModalEventsClickCopyButton: {
        eventName: 'finance app copy card number',
        eventType: 'click'
    },
    CardModalEventsModalClose: {
        eventName: 'finance app close card modal',
        eventType: 'click'
    },
    CardModalEventsClickFreezeCard: {
        eventName: 'finance app freeze card',
        eventType: 'click'
    },
    CardModalEventsClickUnfreezeCard: {
        eventName: 'finance app unfreeze card',
        eventType: 'click'
    },
    CardModalEventsBannerShown: {
        eventName: 'finance app update payment method banner',
        eventType: 'load'
    },
    CardModalEventsUpdatePaymentMethod: {
        eventName: 'finance app update payment method',
        eventType: 'click'
    },
    CancelCardModalEventsModalLoaded: {
        eventName: 'finance app open cancel card modal',
        eventType: 'load'
    },
    CancelCardModalEventsModalClosed: {
        eventName: 'finance app close cancel card modal',
        eventType: 'click'
    },
    CancelCardModalEventsClickCancelCard: {
        eventName: 'finance app cancel card',
        eventType: 'click'
    },
    CreateCardModalEventsModalLoaded: {
        eventName: 'finance app open create card modal',
        eventType: 'load'
    },
    CreateCardModalEventsModalClosed: {
        eventName: 'finance app close create card modal',
        eventType: 'click'
    },
    CreateCardModalEventsCreateCard: {
        eventName: 'finance app create card',
        eventType: 'click'
    },
    CreateCardModalEventsCreateCardSuccess: {
        eventName: 'finance app create card',
        eventType: 'success'
    },
    CreateCardModalEventsCreateCardError: {
        eventName: 'finance app create card',
        eventType: 'error'
    },
    ActivateCardEventsClickActivateCard: {
        eventName: 'finance app open activation card modal',
        eventType: 'click'
    },
    ActivateCardEventsSuccessActivateCard: {
        eventName: 'finance app activate card',
        eventType: 'success'
    },
    ActivateCardEventsErrorActivateCard: {
        eventName: 'finance app activate card',
        eventType: 'error'
    },
    DocumentsEventsLoadModal: {
        eventName: 'finance app document download modal',
        eventType: 'load'
    },
    DocumentsEventsClickDownload: {
        eventName: 'finance app confirm document download',
        eventType: 'click'
    },
    DocumentsEventsClickPreview: {
        eventName: 'finance app preview document download',
        eventType: 'click'
    },
    SmartTaxEventsClickLoadModal: {
        eventName: 'smart tax modal',
        eventType: 'click'
    },
    SmartTaxEventsLoadedModal: {
        eventName: 'smart tax modal',
        eventType: 'load'
    },
    SmartTaxEventsClickCloseModal: {
        eventName: 'close smart tax modal',
        eventType: 'click'
    },
    SmartTaxEventsClickEditCalculationField: {
        eventName: 'smart tax edit field',
        eventType: 'click'
    },
    SmartTaxEventsClickCalculate: {
        eventName: 'smart tax calculate',
        eventType: 'click'
    },
    ExpenseTaggingEventLoadedMain: {
        eventName: 'expense detected',
        eventType: 'load'
    },
    ExpenseTaggingEventClickSelectCategoryCTA: {
        eventName: 'expense go to categories',
        eventType: 'click'
    },
    ExpenseTaggingEventLoadedCategoryPicker: {
        eventName: 'expense category picker',
        eventType: 'load'
    },
    ExpenseTaggingEventClickCategorySelected: {
        eventName: 'expense category selected',
        eventType: 'click'
    },
    ExpenseTaggingEventClickSeeMore: {
        eventName: 'expense see more categories',
        eventType: 'click'
    },
    ExpenseTaggingEventClickEditCategory: {
        eventName: 'expense edit category',
        eventType: 'click'
    },
    ExpenseTaggingEventClickSaveCTA: {
        eventName: 'expense save',
        eventType: 'click'
    },
    ExpenseTaggingEventLoadedSummary: {
        eventName: 'expense summary',
        eventType: 'load'
    },
    ExpenseTaggingEventClickDoneCTA: {
        eventName: 'expenses done viewing',
        eventType: 'click'
    },
    ExpenseTaggingEventClickHelpCenter: {
        eventName: 'expenses help center',
        eventType: 'click'
    },
    ExpenseTaggingEventClickEmptyExpenseWidgetPreview: {
        eventName: 'expense widget animation',
        eventType: 'click'
    },
    TransferMoneyEventsClickRecurringTransfer: {
        eventName: 'finance app recurring transfer',
        eventType: 'click'
    },
    TransferMoneyEventsClickTransferMoney: {
        eventName: 'finance app transfer money',
        eventType: 'click'
    },
    TransferMoneyEventsLoadModal: {
        eventName: 'finance app transfer money modal',
        eventType: 'load'
    },
    TransferMoneyEventsClickCloseModal: {
        eventName: 'close transfer money modal',
        eventType: 'click'
    },
    TransferMoneyEventsClickConfirmTransferMoney: {
        eventName: 'confirm detail transfer money modal',
        eventType: 'click'
    },
    TransferMoneyEventsClickSubmitTransferMoney: {
        eventName: 'submit transfer money modal',
        eventType: 'click'
    },
    TransferMoneyEventsStartNewRecurringTransfer: {
        eventName: 'finance start new recurring transfer',
        eventType: 'click'
    },
    TransferMoneyEventsToggleRecurringTransferStatus: {
        eventName: 'finance toggle recurring transfer status',
        eventType: 'click'
    },
    TransferMoneyEventsToggleRecurringTransferStatusSuccess: {
        eventName: 'finance toggle recurring transfer status',
        eventType: 'success'
    },
    TransferMoneyEventsToggleRecurringTransferStatusError: {
        eventName: 'finance toggle recurring transfer status',
        eventType: 'error'
    },
    TransferMoneyEventsCloseRecurringModal: {
        eventName: 'finance close recurring transfer money modal',
        eventType: 'click'
    },
    TransferMoneyEventsConfirmCreateRecipient: {
        eventName: 'finance confirm create recurring transfer',
        eventType: 'click'
    },
    TransferMoneyEventsConfirmCreateRecipientSuccess: {
        eventName: 'finance confirm create recurring transfer',
        eventType: 'success'
    },
    TransferMoneyEventsConfirmCreateRecipientError: {
        eventName: 'finance confirm create recurring transfer',
        eventType: 'error'
    },
    TransferMoneyEventsLearnMoreRecurringTransfers: {
        eventName: 'finance learn more recurring transfers',
        eventType: 'click'
    },
    TaxWithholdingEventsClickStartTaxWithholding: {
        eventName: 'tax withholding load modal',
        eventType: 'click'
    },
    TaxWithholdingEventsLoadModal: {
        eventName: 'tax withholding modal',
        eventType: 'load'
    },
    TaxWithholdingEventsCloseModal: {
        eventName: 'tax withholding close modal',
        eventType: 'click'
    },
    TaxWithholdingEventsClickOptIn: {
        eventName: 'tax withholding opt in',
        eventType: 'click'
    },
    TaxWithholdingEventsSuccessOptIn: {
        eventName: 'tax withholding opt in',
        eventType: 'success'
    },
    TaxWithholdingEventsClickActions: {
        eventName: 'tax withholding actions',
        eventType: 'click'
    },
    TaxWithholdingEventsClickOptOut: {
        eventName: 'tax withholding request opt out',
        eventType: 'click'
    },
    TaxWithholdingEventsLoadOptOutModal: {
        eventName: 'tax withholding opt out modal',
        eventType: 'load'
    },
    TaxWithholdingEventsClickConfirmOptOut: {
        eventName: 'tax withholding confirm opt out',
        eventType: 'click'
    },
    TaxWithholdingEventsClickDiscardOptOut: {
        eventName: 'tax withholding discard opt out',
        eventType: 'click'
    },
    TaxWithholdingEventsSuccessOptOut: {
        eventName: 'tax withholding opt out',
        eventType: 'success'
    },
    TaxWithholdingEventsClickWithdraw: {
        eventName: 'tax withholding request withdrawal',
        eventType: 'click'
    },
    TaxWithholdingEventsLoadWithdrawModal: {
        eventName: 'tax withholding withdrawal modal',
        eventType: 'load'
    },
    TaxWithholdingEventsClickConfirmWithdraw: {
        eventName: 'tax withholding confirm withdrawal',
        eventType: 'click'
    },
    TaxWithholdingEventsClickDiscardWithdraw: {
        eventName: 'tax withholding discard withdrawal',
        eventType: 'click'
    },
    TaxWithholdingEventsSuccessWithdraw: {
        eventName: 'tax withholding withdrawal',
        eventType: 'success'
    },
    TransferMoneyEventsWithRecipientLoadSelectRecipient: {
        eventName: 'finance app transfer money select recipient',
        eventType: 'load'
    },
    TransferMoneyEventsWithRecipientRecipientDetails: {
        eventName: 'finance app transfer money recipient details',
        eventType: 'click'
    },
    TransferMoneyEventsWithRecipientLoadRecipientDetails: {
        eventName: 'finance app transfer money recipient details',
        eventType: 'load'
    },
    TransferMoneyEventsWithRecipientSuccessRecipientDetails: {
        eventName: 'finance app transfer money recipient details',
        eventType: 'success'
    },
    TransferMoneyEventsWithRecipientErrorRecipientDetails: {
        eventName: 'finance app transfer money recipient details',
        eventType: 'error'
    },
    TransferMoneyEventsWithRecipientClickAddRecipientDropdown: {
        eventName: 'finance app transfer money add recipient from dropdown',
        eventType: 'click'
    },
    TransferMoneyEventsWithRecipientClickBackStep: {
        eventName: 'finance app transfer money back',
        eventType: 'click'
    },
    TransferMoneyEventsWithRecipientClickNextStep: {
        eventName: 'finance app transfer money next',
        eventType: 'click'
    },
    TransferMoneyEventsWithRecipientCloseModal: {
        eventName: 'finance app close transfer money modal with recipient',
        eventType: 'click'
    },
    TransferMoneyEventsWithRecipientSuccessTransferMoney: {
        eventName: 'finance app transfer money',
        eventType: 'success'
    },
    TransferMoneyEventsWithRecipientErrorTransferMoney: {
        eventName: 'finance app transfer money',
        eventType: 'error'
    },
    TransferMoneyEventsWithRecipientUseCardBannerLoad: {
        eventName: 'finance app transfer money use card banner',
        eventType: 'load'
    },
    TransferMoneyEventsWithRecipientUseCardBannerLinkClick: {
        eventName: 'finance app transfer money use card banner link',
        eventType: 'click'
    },
    KYCEventsPageLoaded: {
        eventName: 'finance kyc',
        eventType: 'load'
    },
    KYCEventsBackClick: {
        eventName: 'finance kyc back',
        eventType: 'click'
    },
    KYCEventsCloseClick: {
        eventName: 'finance kyc close',
        eventType: 'click'
    },
    KYCEventsNextClick: {
        eventName: 'finance kyc next',
        eventType: 'click'
    },
    KYCEventsBeneficialOwnerAdded: {
        eventName: 'finance kyc add beneficial owner',
        eventType: 'click'
    },
    KYCEventsBeneficialOwnerRemoved: {
        eventName: 'finance ky cremove beneficial owner',
        eventType: 'click'
    },
    KYCEventsBeneficialOwnerRemoveConfirm: {
        eventName: 'finance kyc confirm removal of beneficial owner',
        eventType: 'click'
    },
    KYCEventsBusinessCheckbox: {
        eventName: 'finance kyc business information certification checkbox',
        eventType: 'click'
    },
    KYCEventsFormSubmitted: {
        eventName: 'finance kyc submit',
        eventType: 'click'
    },
    KYCEventsAgreementCheckbox: {
        eventName: 'finance kyc agreement checkbox',
        eventType: 'click'
    },
    KYCEventsCompleted: {
        eventName: 'finance kyc completed',
        eventType: 'success'
    },
    KYCEventsError: {
        eventName: 'finance kyc error',
        eventType: 'error'
    },
    KYCEventsKyc: {
        eventName: 'finance kyc',
        eventType: 'pageview'
    },
    KYCEventsBeneficialOwnerNeeded: {
        eventName: 'finance kyc beneficial owner detail',
        eventType: 'pageview'
    },
    KYCEventsEntityTypeSelected: {
        eventName: 'finance kyc entity type selected',
        eventType: 'click'
    },
    ApplicationEventsPageLoaded: {
        eventName: 'finance kyc upload documents',
        eventType: 'load'
    },
    ApplicationEventsAttachmentClick: {
        eventName: 'finance kyc upload document',
        eventType: 'click'
    },
    ApplicationEventsSubmitDocuments: {
        eventName: 'finance kyc submit uploaded documents',
        eventType: 'click'
    },
    ApplicationEventsUploadSuccess: {
        eventName: 'finance kyc upload documents',
        eventType: 'success'
    },
    ApplicationEventsUploadError: {
        eventName: 'finance kyc document send failure',
        eventType: 'error'
    },
    ApplicationEventsInvalidFileSize: {
        eventName: 'finance kyc document size exceeds limit',
        eventType: 'error'
    },
    WelcomeEventsPageLoaded: {
        eventName: 'finance welcome page',
        eventType: 'load'
    },
    WelcomeEventsClickCTA: {
        eventName: 'finance welcome cta click',
        eventType: 'click'
    },
    WelcomeEventsFaqClick: {
        eventName: 'finance welcome faq click',
        eventType: 'click'
    },
    WelcomeEventsPaymentSplitsEngaged: {
        eventName: 'finance welcome payment splits engaged',
        eventType: 'click'
    },
    WelcomeEventsPaymentSplitsAmountSet: {
        eventName: 'finance welcome payment splits amount set',
        eventType: 'click'
    },
    SavingPercentageBucketEventsModalLoaded: {
        eventName: 'saving percentage bucket modal',
        eventType: 'load'
    },
    SavingPercentageBucketEventsConfirmClick: {
        eventName: 'saving percentage bucket confirm',
        eventType: 'click'
    },
    SavingPercentageBucketEventsCloseClick: {
        eventName: 'saving percentage bucket close modal',
        eventType: 'click'
    },
    ManualTransferBucketEventsModalLoaded: {
        eventName: 'manual transfer bucket modal',
        eventType: 'load'
    },
    ManualTransferBucketEventsConfirmClick: {
        eventName: 'manual transfer bucket confirm',
        eventType: 'click'
    },
    ManualTransferBucketEventsCloseClick: {
        eventName: 'manual transfer bucket close modal',
        eventType: 'click'
    },
    ManualTransferBucketEventsSuccess: {
        eventName: 'manual transfer bucket',
        eventType: 'success'
    },
    ManualTransferBucketEventsError: {
        eventName: 'manual transfer bucket',
        eventType: 'error'
    },
    CreateSavingsBucketEventsModalLoaded: {
        eventName: 'create savings bucket modal',
        eventType: 'load'
    },
    CreateSavingsBucketEventsConfirmClick: {
        eventName: 'create savings bucket confirm',
        eventType: 'click'
    },
    CreateSavingsBucketEventsCloseClick: {
        eventName: 'create savings bucket close modal',
        eventType: 'click'
    },
    CreateSavingsBucketEventsSuccess: {
        eventName: 'create savings bucket',
        eventType: 'success'
    },
    CreateSavingsBucketEventsError: {
        eventName: 'create savings bucket',
        eventType: 'error'
    },
    EditSavingsBucketEventsModalLoaded: {
        eventName: 'edit savings bucket modal',
        eventType: 'load'
    },
    EditSavingsBucketEventsConfirmClick: {
        eventName: 'edit savings bucket confirm',
        eventType: 'click'
    },
    EditSavingsBucketEventsCloseClick: {
        eventName: 'edit savings bucket close modal',
        eventType: 'click'
    },
    EditSavingsBucketEventsSuccess: {
        eventName: 'edit savings bucket',
        eventType: 'success'
    },
    EditSavingsBucketEventsError: {
        eventName: 'edit savings bucket',
        eventType: 'error'
    },
    DeleteSavingsBucketEventsModalLoaded: {
        eventName: 'delete savings bucket modal',
        eventType: 'load'
    },
    DeleteSavingsBucketEventsConfirmClick: {
        eventName: 'delete savings bucket confirm',
        eventType: 'click'
    },
    DeleteSavingsBucketEventsCloseClick: {
        eventName: 'delete savings bucket close modal',
        eventType: 'click'
    },
    DeleteSavingsBucketEventsSuccess: {
        eventName: 'delete savings bucket',
        eventType: 'success'
    },
    DeleteSavingsBucketEventsError: {
        eventName: 'delete savings bucket',
        eventType: 'error'
    },
    SavingsBucketEventsActionClick: {
        eventName: 'savings bucket menu action',
        eventType: 'click'
    },
    FreezeSavingsBucketEventsModalLoaded: {
        eventName: 'stop saving modal',
        eventType: 'load'
    },
    FreezeSavingsBucketEventsConfirmClick: {
        eventName: 'stop saving confirm',
        eventType: 'click'
    },
    FreezeSavingsBucketEventsCloseClick: {
        eventName: 'stop saving close modal',
        eventType: 'click'
    },
    FreezeSavingsBucketEventsSuccess: {
        eventName: 'stop saving for bucket',
        eventType: 'success'
    },
    FreezeSavingsBucketEventsError: {
        eventName: 'stop saving for bucket',
        eventType: 'error'
    },
    WithdrawBucketSavingsEventsModalLoaded: {
        eventName: 'move savings to balance modal',
        eventType: 'load'
    },
    WithdrawBucketSavingsEventsConfirmClick: {
        eventName: 'move savings to balance confirm',
        eventType: 'click'
    },
    WithdrawBucketSavingsEventsCloseClick: {
        eventName: 'move savings to balance close modal',
        eventType: 'click'
    },
    WithdrawBucketSavingsEventsSuccess: {
        eventName: 'move savings to balance',
        eventType: 'success'
    },
    WithdrawBucketSavingsEventsError: {
        eventName: 'move savings to balance',
        eventType: 'error'
    },
    ProductTourEventsTourStarted: {
        eventName: 'tour started',
        eventType: 'load'
    },
    CashflowInsightEventsBalanceDetailsClick: {
        eventName: 'finance cashflow details',
        eventType: 'click'
    },
    CashflowInsightEventsModalLoaded: {
        eventName: 'finance cashflow details modal',
        eventType: 'load'
    },
    CashflowInsightEventsModalClosed: {
        eventName: 'finance cashflow details close modal',
        eventType: 'click'
    },
    CashflowInsightEventsTimeframeDropdown: {
        eventName: 'finance cashflow timeframe dropdown',
        eventType: 'click'
    },
    CashflowInsightEventsTimeframeDropdownSelect: {
        eventName: 'finance cashflow select timeframe',
        eventType: 'click'
    },
    OverviewEventsLoaded: {
        eventName: 'finance overview',
        eventType: 'load'
    },
    OverviewEventsTaxesCTAClick: {
        eventName: 'finance overview taxes cta',
        eventType: 'click'
    },
    OverviewEventsCardCTAClick: {
        eventName: 'finance overview card cta',
        eventType: 'click'
    },
    HBPaymentsWidgetEventsPaymentsLink: {
        eventName: 'finance hb-payments-widget payments link',
        eventType: 'click'
    },
    HBPaymentsSnapshotEventsPaymentsLink: {
        eventName: 'finance hb-payments-snapshot payments link',
        eventType: 'click'
    },
    OverviewFeaturePromoBannerEventsMoreInfoLink: {
        eventName: 'finance overview feature promo banner more info link',
        eventType: 'click'
    },
    OverviewFeaturePromoBannerEventsCloseBanner: {
        eventName: 'finance overview feature promo banner close',
        eventType: 'click'
    },
    OverviewPromoteBalanceEventsLearnMore: {
        eventName: 'finance overview balance banner learn more',
        eventType: 'click'
    },
    OverviewPromoteBalanceEventsApplyNow: {
        eventName: 'finance overview balance banner apply now',
        eventType: 'click'
    },
    OverviewPromoteBalanceEventsVideoImage: {
        eventName: 'finance overview balance banner video image',
        eventType: 'click'
    },
    OverviewPromoteBalanceEventsVideoModal: {
        eventName: 'finance overview balance banner video modal',
        eventType: 'load'
    },
    OverviewPromoteBalanceEventsWatchedVideo: {
        eventName: 'finance overview balance banner watched most video',
        eventType: 'load'
    },
    OverviewPromoteBalanceEventsCloseVideoModal: {
        eventName: 'finance overview balance banner close video modal',
        eventType: 'click'
    },
    PlaidEventsConnectAccount: {
        eventName: 'finance plaid connect account',
        eventType: 'click'
    },
    PlaidEventsSuccess: {
        eventName: 'finance plaid success',
        eventType: 'success'
    },
    PlaidEventsReconnect: {
        eventName: 'finance plaid reconnect',
        eventType: 'click'
    },
    PlaidEventsExchangePublicTokenError: {
        eventName: 'finance plaid exchange public token error',
        eventType: 'error'
    },
    PlaidEventsLinkTokenError: {
        eventName: 'finance plaid create link token error',
        eventType: 'error'
    },
    PlaidEventsClose: {
        eventName: 'finance plaid close',
        eventType: 'click'
    },
    ExternalAccountsMenuEventsOpen: {
        eventName: 'finance external accounts menu open',
        eventType: 'click'
    },
    ExternalAccountsMenuEventsRename: {
        eventName: 'finance external accounts menu rename',
        eventType: 'click'
    },
    ExternalAccountsMenuEventsDelete: {
        eventName: 'finance external accounts menu delete',
        eventType: 'click'
    },
    ExternalAccountsMenuEventsDeleteModal: {
        eventName: 'finance external accounts menu delete modal',
        eventType: 'click'
    },
    ExternalAccountsMenuEventsViewDetails: {
        eventName: 'finance external accounts menu view details',
        eventType: 'click'
    },
    ExternalAccountsMenuEventsLoadDetailsModal: {
        eventName: 'finance external accounts menu details modal',
        eventType: 'load'
    },
    ExternalAccountsMenuEventsDetailsModalChangeTimeframe: {
        eventName: 'finance external accounts menu details modal change timeframe',
        eventType: 'click'
    },
    ExternalAccountsPopoverEventsOpen: {
        eventName: 'finance external accounts popover open',
        eventType: 'click'
    },
    ExternalAccountsPopoverEventsDismiss: {
        eventName: 'finance external accounts popover dismiss',
        eventType: 'click'
    },
    ExternalAccountsPopoverEventsConnectAccount: {
        eventName: 'finance external accounts popover connect account',
        eventType: 'click'
    },
    ExternalInstitutionDeleteModalEventsModalLoaded: {
        eventName: 'finance external institution delete modal',
        eventType: 'load'
    },
    ExternalInstitutionDeleteModalEventsConfirm: {
        eventName: 'finance external institution delete confirm',
        eventType: 'click'
    },
    ExternalInstitutionDeleteModalEventsClose: {
        eventName: 'finance external institution delete close modal',
        eventType: 'click'
    },
    ExternalInstitutionDeleteModalEventsSuccess: {
        eventName: 'finance external institution delete',
        eventType: 'success'
    },
    ExternalInstitutionDeleteModalEventsError: {
        eventName: 'finance external institution delete',
        eventType: 'error'
    },
    WhitelistEventsPageLoaded: {
        eventName: 'finance white list page',
        eventType: 'load'
    },
    WhitelistEventsWhiteListCTAClick: {
        eventName: 'finance white list cta',
        eventType: 'click'
    },
    WhitelistEventsWhiteListCTAClickSuccess: {
        eventName: 'finance white list cta',
        eventType: 'success'
    },
    WhitelistEventsWhiteListCTAClickError: {
        eventName: 'finance white list cta',
        eventType: 'error'
    },
    WhitelistEventsVideoClick: {
        eventName: 'finance white list video',
        eventType: 'click'
    },
    MWebEventsOverviewPage: {
        eventName: 'finance mweb overview page',
        eventType: 'load'
    },
    MWebEventsKycPage: {
        eventName: 'finance mweb kyc page',
        eventType: 'load'
    },
    MWebEventsDashboardPage: {
        eventName: 'finance mweb dashboard page',
        eventType: 'load'
    },
    MWebEventsOpenApp: {
        eventName: 'finance mweb open app',
        eventType: 'click'
    },
    MWebEventsOverviewLearnMore: {
        eventName: 'finance mweb overview learn more',
        eventType: 'load'
    },
    MWebEventsBalanceFAQ: {
        eventName: 'finance mweb balance faq',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsLoadWidget: {
        eventName: 'yearly revenue goal',
        eventType: 'load'
    },
    YearlyRevenueGoalEventsClickNewGoalCta: {
        eventName: 'yearly revenue goal set new goal cta',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsLoadSetGoalModal: {
        eventName: 'yearly revenue goal set goal modal',
        eventType: 'load'
    },
    YearlyRevenueGoalEventsSubmitGoal: {
        eventName: 'yearly revenue goal set goal modal cta',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsSubmitGoalSuccess: {
        eventName: 'yearly revenue goal set goal modal cta',
        eventType: 'success'
    },
    YearlyRevenueGoalEventsSubmitGoalError: {
        eventName: 'yearly revenue goal set goal modal cta',
        eventType: 'error'
    },
    YearlyRevenueGoalEventsCloseSetGoalModal: {
        eventName: 'yearly revenue goal close set goal modal',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsClickMenuEditGoal: {
        eventName: 'yearly revenue goal menu edit goal',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsClickMenuDeleteGoal: {
        eventName: 'yearly revenue goal menu delete goal',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsLoadReachedGoalModal: {
        eventName: 'yearly revenue goal reached goal modal',
        eventType: 'load'
    },
    YearlyRevenueGoalEventsClickReachedGoalModalCTA: {
        eventName: 'yearly revenue goal reached goal modal cta',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsClickReachedGoalBannerCTA: {
        eventName: 'yearly revenue goal reached goal banner cta',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsLoadDeleteGoalModal: {
        eventName: 'yearly revenue goal delete goal modal',
        eventType: 'load'
    },
    YearlyRevenueGoalEventsClickCloseDeleteGoalModal: {
        eventName: 'yearly revenue goal delete goal modal close',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsClickDeleteGoalCTA: {
        eventName: 'yearly revenue goal delete goal modal cta',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsClickDeleteGoalSuccess: {
        eventName: 'yearly revenue goal delete goal modal cta',
        eventType: 'success'
    },
    YearlyRevenueGoalEventsClickDeleteGoalError: {
        eventName: 'yearly revenue goal delete goal modal cta',
        eventType: 'error'
    },
    YearlyRevenueGoalEventsPopoverLoad: {
        eventName: 'yearly revenue goal popover',
        eventType: 'load'
    },
    YearlyRevenueGoalEventsPopoverClose: {
        eventName: 'yearly revenue goal popover close',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsGoalAchievedToastShown: {
        eventName: 'yearly revenue goal goal achieved toast shown',
        eventType: 'load'
    },
    YearlyRevenueGoalEventsGoalAchievedToastCTA: {
        eventName: 'yearly revenue goal goal achieved toast cta',
        eventType: 'click'
    },
    YearlyRevenueGoalEventsGoalAchievedToastDismissed: {
        eventName: 'yearly revenue goal goal achieved toast dismissed',
        eventType: 'click'
    },
    TaxCategorizationTourLoaded: {
        eventName: 'tax categorization popover',
        eventType: 'load'
    },
    TaxCategorizationTourClose: {
        eventName: 'tax categorization popover close',
        eventType: 'click'
    },
    TaxCategorizationTourNextClick: {
        eventName: 'tax categorization popover cta',
        eventType: 'click'
    },
    FinancialInsightsEventsWidgetLoaded: {
        eventName: 'financial insights widget',
        eventType: 'load'
    },
    FinancialInsightsEventsFeedbackModalLoad: {
        eventName: 'financial insights feedback modal',
        eventType: 'load'
    },
    FinancialInsightsEventsFeedbackModalClick: {
        eventName: 'financial insights feedback modal',
        eventType: 'click'
    },
    FinancialInsightsEventsFeedbackModalCTA: {
        eventName: 'financial insights feedback modal cta',
        eventType: 'click'
    },
    FinancialInsightsEventsFeedbackModalClose: {
        eventName: 'financial insights feedback modal close',
        eventType: 'click'
    },
    FinancialInsightsEventsSuggestModalLoad: {
        eventName: 'financial insights suggest modal',
        eventType: 'load'
    },
    FinancialInsightsEventsSuggestModalCTA: {
        eventName: 'financial insights suggest modal',
        eventType: 'click'
    },
    FinancialInsightsEventsLearnMoreModalClick: {
        eventName: 'financial insights learn more',
        eventType: 'click'
    },
    FinancialInsightsEventsWidgetClick: {
        eventName: 'financial insights widget',
        eventType: 'click'
    },
    FinancialInsightsEventsModalLoaded: {
        eventName: 'financial insights modal',
        eventType: 'load'
    },
    FinancialInsightsEventsModalReactionClick: {
        eventName: 'financial insights modal reaction',
        eventType: 'click'
    },
    FinancialInsightsEventsModalLearnMoreClick: {
        eventName: 'financial insights modal learn more',
        eventType: 'click'
    },
    FinancialInsightsEventsModalCTAClick: {
        eventName: 'financial insights modal cta',
        eventType: 'click'
    },
    FinancialInsightsEventsModalCloseClick: {
        eventName: 'financial insights modal close',
        eventType: 'click'
    },
    FinancialInsightsEventsSuggestModalClose: {
        eventName: 'financial insights suggest modal close',
        eventType: 'click'
    },
    FinanceBusinessInsuranceEventsModalLoaded: {
        eventName: 'finance business insurance modal',
        eventType: 'load'
    },
    FinanceBusinessInsuranceEventsQuoteClick: {
        eventName: 'finance business insurance quote',
        eventType: 'click'
    },
    nceBusinessInsuranceEventsFAQClick: {
        eventName: 'finance business insurance FAQ',
        eventType: 'click'
    },
    FinanceBusinessInsuranceEventsQuoteSuccess: {
        eventName: 'finance business insurance quote',
        eventType: 'success'
    },
    FinanceBusinessInsuranceEventsQuoteError: {
        eventName: 'finance business insurance quote',
        eventType: 'error'
    },
    FinanceBusinessInsuranceEventsModalDismiss: {
        eventName: 'finance business insurance modal dismiss',
        eventType: 'click'
    },
    FinanceBusinessInsuranceEventsBannerLoad: {
        eventName: 'finance business insurance banner',
        eventType: 'load'
    },
    FinanceBusinessInsuranceEventsBannerCTA: {
        eventName: 'finance business insurance banner cta',
        eventType: 'click'
    },
    FinanceBusinessInsuranceEventsBannerDismiss: {
        eventName: 'finance business insurance banner dismiss',
        eventType: 'click'
    },
    TaxHubMWebEventsTaxHubPage: {
        eventName: 'tax hub mweb',
        eventType: 'load'
    },
    TaxHubEventsDownloadDocument: {
        eventName: 'tax hub download document',
        eventType: 'click'
    },
    TaxHubEventsDownloadDocumentSuccess: {
        eventName: 'tax hub download document',
        eventType: 'success'
    },
    TaxHubEventsDownloadDocumentError: {
        eventName: 'tax hub download document',
        eventType: 'error'
    },
    TaxHubEventsContactSupport: {
        eventName: 'contact support',
        eventType: 'click'
    },
    TaxHubEventsLearnMore: {
        eventName: 'tax hub learn more',
        eventType: 'click'
    },
    TaxHubEventsFilter: {
        eventName: 'tax hub filter',
        eventType: 'click'
    },
    TaxHubEventsEducationalLink: {
        eventName: 'tax hub educational link',
        eventType: 'click'
    },
    TaxHubEventsDownloadYearlyReportsAndDocumentsSuccess: {
        eventName: 'tax hub download yearly reports and documents',
        eventType: 'success'
    },
    TaxHubEventsDownloadYearlyReportsAndDocumentsError: {
        eventName: 'tax hub download yearly reports and documents',
        eventType: 'error'
    },
    TaxHubEventsDownloadYearlyDocuments: {
        eventName: 'tax hub download yearly documents',
        eventType: 'click'
    },
    TaxHubEventsLoad: {
        eventName: 'tax hub',
        eventType: 'load'
    }
} as const satisfies Record<string, ITrackEvents>;
